import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import { ChartTemplate } from "../chartTemplate";

/* 
dc-js chart template 
 */

const yieldChartFunc = (divRef, ndx) => {
  // Dimension by county
  const crop_yield = ndx.dimension((d) => d.baseTbCode);

  // Compute the crop  yield for every county
  var crop_yield_grp = crop_yield.groupAll().reduceSum(function (d) {
    return d.crop_Yield_Tones;
  });
  //  an intance of the dc chart
  const yieldChart = dc.numberDisplay(divRef);
  yieldChart
    .formatNumber(d3.format(",.0f"))
    .group(crop_yield_grp)
    .valueAccessor((d) => {
      return d;
    });
  //  return the chart object to  the ChartTemplate
  return yieldChart;
};

export const CropYieldChart = (props) => (
  <ChartTemplate
    //  pass the chart object as a prop to the chart  function
    chartFunction={yieldChartFunc}
    //    title="Yield(Ton/ha)"
  />
);
